export const MAX_SPECIFIC_SKILL_TRANSITION_MONTH_PERIOD = 0;
export const MAX_SPECIFIC_SKILL_TRANSITION_YEAR_PERIOD = 5;
export const SPECIFIC_SKILL_TRANSITION_PERIOD_ERROR_MESSAGE = "「特定技能1号残存期間」は最大5年0ヶ月までに設定してください。";
